import './App.css';
import { Navigate, BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import BottomFooter from './components/sub-components/BottomFooter';
import Home from './pages/Home';
import DoubleRoom from './pages/DoubleRoom';
import FamilyRoom from './pages/FamilyRoom';
import TwinRoom from './pages/TwinRoom';
import ReservationPage from './pages/Reserve';
import LoginForm from './pages/Login';
import PrivacyPolicy from './pages/PrivacyPolicy';
import SettingsPage from './Admin/SettingsPage';

function App() {
  const token = localStorage.getItem('token');  // Get token from localStorage

  return (
    <div className="App">
      <Router>
      <Header></Header>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/reserving" element={<ReservationPage />} />
        <Route path="/double-room" element={<DoubleRoom />} />
        <Route path="/twin-room" element={<TwinRoom />} />
        <Route path="/family-room" element={<FamilyRoom />} />
        <Route path="/login" element={<LoginForm/>} />
        <Route path="/dashboard/*" element={token ? <SettingsPage/> : <Navigate to="/login" />}/>
        <Route path="/privacy" element={<PrivacyPolicy/>} />
      </Routes>
    </Router>
    <Footer></Footer>
    <BottomFooter></BottomFooter>
    </div>
  );
}

export default App;
